import { apiFetch } from './apiClient.js';

export type ApiKeyScope =
  | 'read:all' | 'write:all' | 'admin'
  | 'channels:read' | 'channels:write'
  | 'campaigns:read' | 'campaigns:write'
  | 'flows:read' | 'flows:write';

export interface ApiKey {
  id: string;
  tenantId: string;
  name: string;
  prefix: string;
  scopes: ApiKeyScope[];
  status: 'active' | 'revoked';
  expiresAt?: string;
  lastUsedAt?: string;
  description?: string;
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface CreateApiKeyBody {
  name: string;
  scopes: ApiKeyScope[];
  description?: string;
  expiresAt?: string;
}

export interface CreateApiKeyResult extends ApiKey {
  /** Secret en claro. Solo se devuelve en la respuesta del POST create. */
  plainSecret: string;
  _warning: string;
}

export async function listApiKeys(
  tenantId: string,
  opts: { includeRevoked?: boolean } = {},
): Promise<ApiKey[]> {
  const qs = opts.includeRevoked ? '?includeRevoked=true' : '';
  const res = await apiFetch<{ items: ApiKey[] }>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/api-keys${qs}`,
  );
  return res.items;
}

export async function createApiKey(
  tenantId: string,
  body: CreateApiKeyBody,
): Promise<CreateApiKeyResult> {
  return apiFetch<CreateApiKeyResult>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/api-keys`,
    { method: 'POST', body },
  );
}

export async function revokeApiKey(tenantId: string, id: string): Promise<ApiKey> {
  return apiFetch<ApiKey>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/api-keys/${encodeURIComponent(id)}/revoke`,
    { method: 'POST' },
  );
}
